// extracted by mini-css-extract-plugin
export var navbarSubLink = "F_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "F_vc d_f0 d_dB";
export var subPageLink = "F_gf d_gf";
export var burger = "F_vB";
export var sublinkSize = "F_vC";
export var linkSize = "F_vD";
export var Link = "F_sb t_sb t_rD t_rY";